export class GlobalCripto {

    public static clientAPI: any;

    public static apiAtiva: string;

}